



















































import { Component, PropSync, Vue, Emit } from 'vue-property-decorator';
import { Dictionary } from 'lodash';
import SimpleSnackbar from '@/components/Snackbar/SimpleSnackbar.vue';
import DialogConfirm from '@/components/Dialog/DialogConfirm.vue';
import { ExportType } from '@/models/Export';

@Component({
  components: {
    SimpleSnackbar,
    DialogConfirm,
  },
})
export default class DownloadDialog extends Vue {
  @PropSync('loading', { default: false }) exportLoading!: boolean;

  @PropSync('disabledExport', { default: false }) disabled!: boolean;

  @PropSync('availableExport', { default: false }) fileFormats!: ExportType[] | string[];

  get query(): Dictionary<string | (string | null)[]> {
    const { query } = this.$route;
    delete query.Precise;
    return query;
  }

  get showFilters(): boolean {
    return Object.keys(this.query).length > 0;
  }

  public dialogOpen = false;

  public radioValue: ExportType | string = ExportType.CSV;

  public close(): void {
    this.dialogOpen = false;
  }

  @Emit('exportTable')
  public exportTable(): ExportType | string {
    return this.radioValue;
  }
}
